<app-header-technicien-chauffeur [Titre]="'Liste des crémations en cours'"></app-header-technicien-chauffeur>
<div class="Container">
    <div class="ContainerFournee">
        <button (click)="this.CreationFournee()" id="CreationFournee">
            <span id="txtCreation">Créer une fournée</span>
            <span id="arrow">➜</span>
        </button>
        <br>
        <p id="Titre">Animaux en cours de crémation</p>
        <br>
        <app-carte-animal [Commandes]="Commandes"></app-carte-animal>
    </div>
</div>